module.exports = __webpack_public_path__ + "static/media/ic_location_on_black_24px.fb8f4160.svg";